import React from 'react';
import TopObserver from './Observer';

const TopForHomepage = ({ ids }) => !window.onServer && <TopObserver ids={ids} />;

export default TopForHomepage;
